(function (window, document, undefined) {
  "use strict";

  /**
   * Initialize.
   * Find all vplus-ticker instances that have not been intizialized yet
   * and add event handlers to to all ticker item anchor elements.
   *
   * @return {undefined}
   */
  const _init = () => {
    const tickers = document.querySelectorAll(".vodl-vplus-ticker.pre-init");
    if (0 === tickers.length) {
      return;
    }

    tickers.forEach((ticker) => {
      let tickerItems = ticker.querySelectorAll(".vodl-vplus-ticker__list a");

      if (tickerItems.length > 0) {
        tickerItems.forEach((item) => {
          item.addEventListener("click", handleItemClick);
        });
      }

      ticker.classList.remove("pre-init");
    });
  };

  /**
   * Handles the click on a tickerItem found via _init().
   *
   * @param {Event} e
   */
  const handleItemClick = (e) => {
    const link = e.currentTarget;
    const currentTicker = link.closest(".vodl-vplus-ticker");

    const targetUrl = link.href || false;
    let eventCategory = "vplus_ticker";

    if (
      currentTicker &&
      currentTicker.dataset &&
      currentTicker.dataset.trackingPrefix
    ) {
      eventCategory =
        currentTicker.dataset.trackingPrefix + "-" + eventCategory;
    }

    trackGA(eventCategory, targetUrl);
  };

  /**
   * Handles analytics tracking by pushing a new object into the
   * window.dataLayer array.
   *
   * @param {string} eventCategory  The event category.
   * @param {string} eventLabel     The event label.
   */
  const trackGA = (eventCategory, eventLabel) => {
    eventCategory = eventCategory || false;
    eventLabel = eventLabel || false;

    if (eventCategory && eventLabel) {
      window.dataLayer = window.dataLayer || [];
      const eventData = {
        event: "genericEvent",
        eventCategory,
        eventAction: "click",
        eventLabel,
      };

      window.dataLayer.push(eventData);

      document.dispatchEvent(
        new CustomEvent("hansrmdtevent", { detail: eventData })
      );
    }
  };

  _init();
  window.addEventListener("newPage", _init, false);
})(window, document);
